// Module
var code = "<template accent.bind=\"accent & attr\" click.trigger=\"$event.__ignoreRowClick = true\"> <require from=\"./data-table-details.scss\"></require> <slot></slot> </template> ";
// Exports
module.exports = code;